'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _videoPlayer = require('video-player');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = function (_React$Component) {
  (0, _inherits3.default)(Wrapper, _React$Component);

  function Wrapper(props) {
    (0, _classCallCheck3.default)(this, Wrapper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Wrapper.__proto__ || (0, _getPrototypeOf2.default)(Wrapper)).call(this, props));

    _this.containerForCustomUI = document.createElement('div');

    _this.callProperPlaybackCallback = _this.callProperPlaybackCallback.bind(_this);
    _this.setPlayerNodeRef = _this.setPlayerNodeRef.bind(_this);
    _this.setChildrenContainerNodeRef = _this.setChildrenContainerNodeRef.bind(_this);
    _this.processFullScreenCallbackChange = _this.processFullScreenCallbackChange.bind(_this);

    _this.createPlayerInstance(props);
    _this.attachCallbacks(props);
    return _this;
  }

  (0, _createClass3.default)(Wrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.appendPlayerNode();
      this.appendChildNodeToWrapper();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updatePlayerBasicProps(nextProps);
      this.updatePlaybackStatus(nextProps);
      this.updatePlayerUI(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unAttachCallbacks();
      this.player.destroy();
      this.containerForCustomUI = null;
    }
  }, {
    key: 'createPlayerInstance',
    value: function createPlayerInstance(props) {
      var size = (0, _pick3.default)(props, ['width', 'height']);

      var onPlaybackAnomaly = props.onPlaybackAnomaly;

      var logger = false;

      if (onPlaybackAnomaly) {
        logger = {
          callback: onPlaybackAnomaly
        };
      }

      var overlay = props.overlay || false;

      this.player = new Wrapper._Player((0, _extends3.default)({
        size: size
      }, (0, _pick3.default)(props, ['src', 'preload', 'autoPlay', 'loop', 'muted', 'volume', 'controls', 'playInline', 'loader', 'screen']), {
        overlay: overlay,
        logger: logger
      }));

      if (props.shouldTriggerPlay && props.shouldTriggerPause) {
        console.warn('VideoPlayerWrapper: shouldTriggerPause and shouldTriggerPause both true'); // eslint-disable-line no-console
      } else {
        if (props.shouldTriggerPlay) {
          this.player.play();
          if (props.isInFullScreen) {
            this.player.enterFullScreen();
          }
        }

        if (props.shouldTriggerPause) {
          this.player.pause();
        }
      }

      this.player.ui.screen.view.appendComponentNode(this.containerForCustomUI);
    }
  }, {
    key: 'attachCallbacks',
    value: function attachCallbacks(props) {
      this.player.on(_videoPlayer.VIDEO_EVENTS.ERROR, props.onError);
      this.player.on(_videoPlayer.VIDEO_EVENTS.STATE_CHANGED, this.callProperPlaybackCallback);

      this.player.on(_videoPlayer.UI_EVENTS.MUTE_STATUS_TRIGGERED, props.onMuteStatusChange);
      this.player.on(_videoPlayer.UI_EVENTS.VOLUME_CHANGE_TRIGGERED, props.onVolumeLevelChange);
      this.player.on(_videoPlayer.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.processFullScreenCallbackChange);
    }
  }, {
    key: 'processFullScreenCallbackChange',
    value: function processFullScreenCallbackChange(status) {
      if (status) {
        this.props.onFullScreenEnter();
      } else {
        this.props.onFullScreenExit();
      }
    }
  }, {
    key: 'unAttachCallbacks',
    value: function unAttachCallbacks() {
      var props = this.props;


      this.player.off(_videoPlayer.VIDEO_EVENTS.ERROR, props.onError);
      this.player.off(_videoPlayer.VIDEO_EVENTS.STATE_CHANGED, this.callProperPlaybackCallback);

      this.player.off(_videoPlayer.UI_EVENTS.MUTE_STATUS_TRIGGERED, props.onMuteStatusChange);
      this.player.off(_videoPlayer.UI_EVENTS.VOLUME_CHANGE_TRIGGERED, props.onVolumeLevelChange);
      this.player.off(_videoPlayer.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.processFullScreenCallbackChange);
    }
  }, {
    key: 'callProperPlaybackCallback',
    value: function callProperPlaybackCallback(_ref) {
      var state = _ref.nextState;
      var STATES = this.player._engine.STATES;

      if (state === STATES.PLAYING) {
        this.props.onPlay();
      }

      if (state === STATES.PAUSED) {
        this.props.onPause();
      }

      if (state === STATES.ENDED) {
        this.props.onEnd();
      }
    }
  }, {
    key: 'updatePlaybackStatus',
    value: function updatePlaybackStatus(_ref2) {
      var shouldTriggerPlay = _ref2.shouldTriggerPlay,
          shouldTriggerPause = _ref2.shouldTriggerPause,
          isInFullScreen = _ref2.isInFullScreen;

      if (shouldTriggerPlay && shouldTriggerPause) {
        console.warn('VideoPlayerWrapper: shouldTriggerPause and shouldTriggerPause both true'); // eslint-disable-line no-console

        return null;
      }

      if (shouldTriggerPlay && this.props.shouldTriggerPlay !== shouldTriggerPlay) {
        this.player.play();

        if (isInFullScreen && !this.player.isInFullScreen) {
          this.player.enterFullScreen();
        }
      }

      if (shouldTriggerPause && this.props.shouldTriggerPause !== shouldTriggerPause) {
        this.player.pause();
      }
    }
  }, {
    key: 'updatePlayerBasicProps',
    value: function updatePlayerBasicProps(_ref3) {
      var src = _ref3.src,
          autoPlay = _ref3.autoPlay,
          muted = _ref3.muted,
          loop = _ref3.loop,
          volume = _ref3.volume,
          preload = _ref3.preload,
          playInline = _ref3.playInline;

      if (!(0, _isEqual3.default)(this.props.src, src)) {
        this.player.setSrc(src);
      }

      if (this.props.autoPlay !== autoPlay) {
        this.player.setAutoPlay(autoPlay);
      }

      if (this.props.muted !== muted) {
        this.player.setMute(muted);
      }

      if (this.props.loop !== loop) {
        this.player.setLoop(loop);
      }

      if (this.props.volume !== volume) {
        this.player.setVolume(volume);
      }

      if (this.props.preload !== preload) {
        this.player.setPreload(preload);
      }

      if (this.props.playInline !== playInline) {
        this.player.setPlayInline(playInline);
      }
    }
  }, {
    key: 'updatePlayerUI',
    value: function updatePlayerUI(_ref4) {
      var width = _ref4.width,
          height = _ref4.height,
          isInFullScreen = _ref4.isInFullScreen;

      if (this.props.width !== width) {
        this.player.ui.setWidth(width);
      }

      if (this.props.height !== height) {
        this.player.ui.setHeight(height);
      }

      if (this.props.isInFullScreen !== isInFullScreen) {
        if (isInFullScreen) {
          this.player.enterFullScreen();
        } else {
          this.player.exitFullScreen();
        }
      }
    }
  }, {
    key: 'setPlayerNodeRef',
    value: function setPlayerNodeRef(node) {
      this.playerNode = node;
    }
  }, {
    key: 'setChildrenContainerNodeRef',
    value: function setChildrenContainerNodeRef(node) {
      this.childrenContainerNode = node;
    }
  }, {
    key: 'appendPlayerNode',
    value: function appendPlayerNode() {
      this.playerNode.appendChild(this.player.node);
    }
  }, {
    key: 'appendChildNodeToWrapper',
    value: function appendChildNodeToWrapper() {
      this.containerForCustomUI.appendChild(this.childrenContainerNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement('section', { ref: this.setPlayerNodeRef }),
        _react2.default.createElement(
          'section',
          { ref: this.setChildrenContainerNodeRef },
          this.extendedChildren
        )
      );
    }
  }, {
    key: 'extendedChildren',
    get: function get() {
      var _this2 = this;

      var children = this.props.children;


      return _react2.default.Children.map(children, function (child) {
        if ((0, _isString3.default)(child.type)) {
          return child;
        }
        return _react2.default.cloneElement(child, {
          eventEmitter: _this2.player._eventEmitter,
          engine: _this2.player._engine,
          ui: _this2.player.ui
        });
      });
    }
  }]);
  return Wrapper;
}(_react2.default.Component);

Wrapper._Player = _videoPlayer.Player;
Wrapper.propTypes = {
  width: _propTypes.number,
  height: _propTypes.number,

  src: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]),

  autoPlay: _propTypes.bool,
  muted: _propTypes.bool,
  loop: _propTypes.bool,
  volume: _propTypes.number,
  preload: _propTypes.string,
  playInline: _propTypes.bool,

  overlay: _propTypes.any,
  loader: _propTypes.any,
  screen: _propTypes.any,
  controls: _propTypes.any,

  shouldTriggerPlay: _propTypes.bool,
  shouldTriggerPause: _propTypes.bool,
  isInFullScreen: _propTypes.bool,

  onPlaybackAnomaly: _propTypes.func,

  onPlay: _propTypes.func,
  onPause: _propTypes.func,
  onEnd: _propTypes.func,
  onMuteStatusChange: _propTypes.func,
  onVolumeLevelChange: _propTypes.func,
  onFullScreenEnter: _propTypes.func,
  onFullScreenExit: _propTypes.func
};
Wrapper.defaultProps = {
  onPlay: _noop3.default,
  onPause: _noop3.default,
  onEnd: _noop3.default,

  onPlaybackAnomaly: _noop3.default,

  onMuteStatusChange: _noop3.default,
  onFullScreenEnter: _noop3.default,
  onFullScreenExit: _noop3.default,
  onVolumeLevelChange: _noop3.default
};
exports.default = Wrapper;
//# sourceMappingURL=wrapper.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player-react/dist/src/wrapper/wrapper.js
// module id = 1690
// module chunks = 1 2 3